/** Minimum nights per stay (check-out must be at least this many calendar days after check-in). */
export const MIN_BOOKING_NIGHTS = 3;

/** Deposit percentage taken to confirm a booking (keep in sync with the Terms & Conditions page). */
export const DEPOSIT_PERCENT = 30;

/** How many days before arrival the balance is due (keep in sync with the Terms & Conditions page). */
export const BALANCE_DUE_DAYS = 7;
